import React, { useEffect, useState } from 'react';
import { ButtonDefault, FieldCheck, FieldDropdown, FieldNumber, FieldText, LoadSpin, PanelBase } from 'dw-components';
import moment from 'moment';
import { firebaseApp } from '../../../../API/firebaseApp';
import { message } from 'antd';
import { get, getDatabase, ref } from 'firebase/database';

const ProductTypeNew = (props) => {

    const [initData, setInitData] = useState({
        id: props.id,
        name: null,
        price: 0,
        created: moment().format("YYYY.MM.DD HH:mm:ss")
    });
    const [data, setData] = useState({});
    const [checkRule, setCheckRule] = useState(false);
    const [rowIndex, setRowIndex] = useState(-1);
    const [loading, setLoading] = useState(false);
    const [dProduct, setDProduct] = useState([]);

    const getData = async () => {
        let tData = { ...initData };
        let tIndex = -1;
        if (props.id && props.data?.length > 0) {

            tIndex = props.data.map(r => r.id).indexOf(props.id);

            if (tIndex >= 0) {
                tData = props.data[tIndex];
            }
        }
        setData(tData);
        setRowIndex(tIndex);
    }

    const getInitData = async () => {
        setLoading(true);
        let tDProdcut = [];
        await get(ref(getDatabase(firebaseApp), "product")).then(response => {
            let resp = response.toJSON();
            if (resp) {
                Object.keys(resp)?.map(key => {
                    tDProdcut.push({
                        key: key,
                        text: resp[key]?.name
                    });
                });
            }
        });
        setDProduct(tDProdcut);
        setLoading(false);
    }

    useEffect(() => {
        getData();
    }, [props.id]);

    useEffect(() => {
        getInitData();
    }, []);

    const fieldOnChanged = async (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }

            setData(tData);
        }
    }

    const onSave = async () => {

        setCheckRule(true);
        let vRule = true;

        if (!data.name
            || !data.price
            || !data.productid) {
            vRule = false;
        }

        if (vRule) {

            let tData = { ...data };

            if (rowIndex < 0) {
                tData.id = props.id;
                tData.created = moment().format("YYYY.MM.DD HH:mm:ss");
            }
            if (props.onAfterSave) {
                props.onAfterSave(tData);
            }
            onDismiss();
        }
    }

    const onDismiss = () => {
        setCheckRule(false);
        setData({ ...initData });
        if (props.onDismiss) {
            props.onDismiss();
        }
    }

    return (
        <div>
            <PanelBase
                delete
                onDelete={() => props.onDelete(props.id)}
                isOpen={props.isOpen}
                onDismiss={onDismiss}
                headerText={rowIndex >= 0 ? "Хэмжээ засах" : "Хэмжээ нэмэх"}
                buttons={(
                    <ButtonDefault onClick={onSave} text="Хадгалах" />
                )}
            >
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown loading={loading} required title="Барааны нэр" onChanged={fieldOnChanged} keyfield='productid' keyfieldname='productname' defaultValue={data?.productid} checkreq={checkRule} data={dProduct} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldText required title="Хэмжээ нэр" onChanged={fieldOnChanged} keyfield='name' defaultValue={data?.name} checkreq={checkRule} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldNumber required title="Үнэ" onChanged={fieldOnChanged} keyfield='price' defaultValue={data?.price} checkreq={checkRule} />
                </div>
            </PanelBase>
        </div>
    );
}

export default ProductTypeNew;